// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"48":"d0903446","961":"d49e959f"}[chunkId] + ".chunk.css";
};